import { render, staticRenderFns } from "./CompetitionViolations.vue?vue&type=template&id=414a732a&lang=pug"
import script from "./CompetitionViolations.vue?vue&type=script&lang=js"
export * from "./CompetitionViolations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports